<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        :label="label"
        prepend-inner-icon="mdi-calendar-month-outline"
        readonly
        v-bind="attrs"
        v-on="on"
        filled
        hide-details="auto"
        @click:prepend-inner="menu = true"
        clearable
        @click:clear="date = null"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @input="menu = false"
      no-title
      :min="minDate"
      :max="maxDate"
      :month-format="getMonthFormat"
      :header-date-format="getHeaderDateFormat"
      :title-date-format="getTitleDateFormat"
      :weekday-format="getWeekdayFormat"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { format, parseISO } from "date-fns";
import datePickerFormatterMixin from "@/mixins/datePickerMixins";

export default {
  mixins: [datePickerFormatterMixin],
  props: {
    value: {
      type: [String, Date, null],
    },
    label: String,
    minDate: String,
    maxDate: String,
    rules: Array,
  },
  data() {
    return {
      menu: false,
      date: null,
    };
  },
  watch: {
    date: {
      handler(val) {
        this.$emit("input", val);
      },
    },
    value: {
      handler(val) {
        this.date = val;
      },
    },
  },
  computed: {
    formattedDate() {
      if (!this.date) return;
      return format(parseISO(this.date), "dd.MM.yyyy");
    },
  },
  created() {
    this.date = this.value;
  },
};
</script>
